<template>
	<div>
		<c-dialog ref="dialog" title="选择礼包" width="800" @resolve="resolve">
			<m-search ref="search" @search="search">
				<c-form ref="form" inline>
                    <c-form-item type="input" label="礼包名称" name="name"></c-form-item>
				</c-form>
			</m-search>
				
			<c-table ref="table" height="400">
				<c-table-column
					type="selector"
					:multiple="!!multiple"
				></c-table-column>
				
                <c-table-column
                        label="礼包名称"
                        name="name"
                        width="200"
                >
                </c-table-column>

                <c-table-column
                        label="礼包价值(元)"
                        name="total_price"
                        width="200"
                >
                    <template v-slot="{data}">
						<span v-if="data.total_price">{{'¥' + data.total_price.toFixed(2)}}</span>
                    </template>
                </c-table-column>
			</c-table>
		</c-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		props: {
			multiple: Boolean
		},
		
		data() {
			return {
			}
		},
		
		methods: {
			search(data) {
				this.$refs.table.load({
					url: '/gift_package/list',
					data
				});
			},
			
			open(sta_type) {
				this.$refs.form.clear();
				this.$refs.search.search();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择礼包'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>